module.exports = __webpack_public_path__ + "media/images/webpage/hotels/743/meal-45aeb44d69ca1d832c159f1951de5b2b.webp";